export async function apiFetch(url, options = {}) {
  const r = await fetch(url, options);
  if (!r.ok) {
    // Session expirée/absente (P1-Login, 27/07/2026) : diffuse un événement
    // global pour qu'App.jsx puisse réafficher l'écran de connexion sans avoir
    // à faire transiter ce state à travers chaque composant appelant apiFetch.
    if (r.status === 401) {
      window.dispatchEvent(new Event("v3:auth-expired"));
    }
    const err = await r.json().catch(() => ({ detail: r.statusText }));
    throw new Error(err.detail || r.statusText);
  }
  return r.json();
}
